import $ from 'jquery';

import './vendor/wordpress/navigation';
import './vendor/wordpress/skip-link-focus-fix';

//default stripe stuff
var stripe = Stripe('pk_live_4Vfl9vZRsePxq1HAHCpLe8Iv');

var elements = stripe.elements();
var cardElement = elements.create('card');
cardElement.mount('#card-element');

var cardholderName = document.getElementById('cardholder-name');
var cardButton = document.getElementById('card-button');

var amountField = document.getElementById('invoice-amount');

cardButton.addEventListener('click', function(ev) {
  ev.preventDefault();
  //create a new post request to pass back to template
    var data = $('#stripeform').serializeArray();
    data.push({
      name: "ajax",
      value: "true"
    });
    $.post(window.location, data, function(data, status) {
        //send transaction off to stripe with new secret generated in template
        stripe.handleCardPayment(
          data.intent, cardElement, {
            payment_method_data: {
              billing_details: {name: cardholderName.value}
            }
          }
        ).then(function(result) {
          if (result.error) {
            // Display error.message in your UI.
          } else {
            $('#stripeform').remove();
            $('.StripeDescription').html("Thank you, your payment has been successful.");
          }
        });
      });
});
